import { render } from "./ImageViewer.vue?vue&type=template&id=0ac3505a&scoped=true"
import script from "./ImageViewer.vue?vue&type=script&lang=js"
export * from "./ImageViewer.vue?vue&type=script&lang=js"

import "./ImageViewer.vue?vue&type=style&index=0&id=0ac3505a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ac3505a"]])

export default __exports__